<template>
  <component v-if="ui.loaded" :is="timelineComponent" :timeline="timeline" @refresh="refresh"></component>
</template>

<script>
  import api from 'api'

  export default {
    computed: {
      timelineComponent() {
        return () => import(`components/PatientTimeline/${this.$store.getters['application/application'].name}PatientTimeline.vue`)
      }
    },

    data() {
      return {
        timeline: {},
        ui: {
          loaded: false
        }
      }
    },

    methods: {
      refresh() {
        api.get(`patients/${this.$route.params.patient_id}/timeline`)
          .then(res => {
            this.timeline = res.data
            this.ui.loaded = true
          })
      }
    },

    mounted() {
      this.refresh()
    }
  }
</script>
